import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import { useEffect, useState } from "react";
import { DatesSetArg, EventClickArg, EventInput } from "@fullcalendar/core/index.js";
import { parseConfirmedDealsToEvents } from "../../../utils/calendarUtils";
import { ModalContainer } from "../../../components/ui/ModalContainer";
import { ConfirmedDealsContainer } from "../ConfirmedDealCards/components";
import { useGetVisitsForCalendarQuery } from "../../../api/visitasApi";

export function Calendario() {
    const [tasks, setTasks] = useState<EventInput>([])
    const [showModal, setShowModal] = useState(false);
    const [dateSelected, setDateSelected] = useState<string | null>(null);
    const [currentDate, setCurrentDate] = useState<{ year: number, month: number}>(() => {
        const date = new Date();
        return {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
        }
    });

    const { data: deals } = useGetVisitsForCalendarQuery(currentDate);

    useEffect(() => {
        setTasks(parseConfirmedDealsToEvents(deals ?? []));
    }, [deals])

    const handleClick = (dateInfo: DateClickArg) => {
        setShowModal(true);
        setDateSelected(dateInfo.dateStr);
    }

    const handleEventClick = (eventInfo: EventClickArg) => {
        setShowModal(true);
        setDateSelected(eventInfo.event.startStr);
    } 

    const handelDateSet = (dateInfo: DatesSetArg) => {
        const month = dateInfo.view.currentStart.getMonth() + 1;
        const year = dateInfo.view.currentStart.getFullYear()
        setCurrentDate({ year, month });
    }

    return (
        <>
            <FullCalendar
                plugins={[ dayGridPlugin, interactionPlugin ]}
                dateClick={handleClick}
                eventClick={handleEventClick}
                height={"90%"}
                aspectRatio={3}
                locale="es"
                headerToolbar={{ center: "dayGridYear,dayGridMonth,dayGridWeek,dayGridDay"}}
                initialView="dayGridMonth"
                events={tasks} datesSet={handelDateSet}/>

            {showModal && (
            <ModalContainer>
                <ConfirmedDealsContainer 
                    dateSelected={dateSelected!}
                    setShowModal={setShowModal}/>
            </ModalContainer>
            )}
        </>

    )
}
